import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var cardHeaderComponentName = 'QuantumCardHeader';
export function getCardHeaderUtilityClass(slot) {
    return generateUtilityClass(cardHeaderComponentName, slot);
}
export var cardHeaderClasses = generateUtilityClasses(cardHeaderComponentName, [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader',
]);
